import {useNavigation} from '@react-navigation/native';
import React, {useCallback, useEffect, useRef, useState} from 'react';
import { Platform} from 'react-native';

import {StationDTO} from '../../../../dtos/StationDTO';
import {ProductDTO} from '../../../../dtos/ProductDTO';

import {
  DistanceIcon,
  Container,
  Distance,
  DistanceContainer,
  PromotionBanner,
  PromotionContainer,
  PromotionText,
  Station,
  StationAddress,
  StationColumn,
  StationContent,
  StationDetails,
  StationImage,
  StationInfos,
  StationName,
  StationNameMedal,
  Arrow,
  PromotionContent,
  PromotionBannerColumn,
  PromotionTextBold,
  WhiteLine,
  PromotionIconRight,
  PromotionIconContainer,
  PromotionEmoji,
  DiscountBanner,
  DiscountBannerColumn,
  DiscountContainer,
  DiscountEmoji,
  DiscountIconContainer,
  DiscountContent,
  DiscountText,
  DiscountIconRight,
  StationNaoDisponivel,
  StationTextNaoDisponivel,
  StationContext,
  StationIcon,
  StationSubtitleNaoDisponivel,
  PricesContainer,
  PromotionArrow,
  PromotionWrapper,
  StationColumnRight,
  Badge,
  BadgeTriangle,
  BadgeText,
  BadgeTextBig,
  StationContainer,
  OTPWarning,
  OTPWarningLight,
} from './styles';
import analytics from '@react-native-firebase/analytics';

import {ConfirmPostModal} from '../../ConfirmPostModal';
import {CuponsModal} from '../../CuponsModal';
import {CouponDTO} from '../../../../dtos/CouponDTO';
import {api, apiv2} from '../../../../services/api';
import {useAuth} from '../../../../context/auth';
import {useShouldShowOTPModal} from '../../../../context/otpModal';
import {Step} from '../../../Interface/Step';

import {ProductCategoryModal} from '../../ProductCategoryModal';
import {getPersistentDeviceId} from '../../../../utils/deviceId';
import {version} from '../../../../../package.json';
import {AutoScrollPrices} from './AutoScrollPrices';
import {RFValue} from 'react-native-responsive-fontsize';

interface IStationItem {
  data: StationDTO;
  tipo?: string;
  showRank?: boolean;
  showFuelPrices?: boolean;
  isUserLocation?: boolean;

  disableAction?: boolean;
  showStationDetails?: boolean;
  actionBeforeNavigate?: () => void;

  stepOrder?: number;
  stepText?: string;
  stepOnPress?: () => void;
}

export function StationItem({
  data,
  tipo,
  showFuelPrices,
  showStationDetails,
  stepOnPress,
  stepOrder,
  stepText,
  disableAction = false,
  showRank = false,
  actionBeforeNavigate,
  isUserLocation = false,
}: IStationItem) {
  const navigation = useNavigation();

  const {
    isLogged,
    setShowSign,
    clientId,
    user,
    setShouldShowOTPModal,
  } = useAuth();
  const shouldShowOTPModal = useShouldShowOTPModal();

  // marca que foi este card que abriu o OTP global
  const otpAbertoAqui = useRef(false);
  const isWebview = Platform.OS === 'web';

  const rank = data.categoria === 'ouro' ? 'gold' : 'silver';

  const [discounts, setDiscounts] = useState<CouponDTO[]>([]);

  const [availableProductTypes, setAvailableProductsTypes] = useState<
    {loja_id: string; tipo_produto: 'string'}[]
  >([]);

  const [availableProductBanner, setAvailableProductBanner] = useState('');

  const [products, setProducts] = useState([] as ProductDTO[]);

  const buscaProdutos = useCallback(async () => {
    try {
      const deviceId = await getPersistentDeviceId();
      const url =
        '/produtosPosto?tipo=' +
        tipo +
        '&regiao=' +
        data.state +
        '&versao=' +
        version +
        '&deviceId=' +
        deviceId;

      const {data: productsData} = await api.get(url);

      setProducts(productsData);
    } catch (error) {
      console.log(error);
    }
  }, [tipo]);

  useEffect(() => {
    if (tipo === 'C') {
      buscaProdutos();
    }
  }, [user.phone_verified, isLogged]);

  const showPromotional = isLogged && !user.phone_verified;
  const hasPromotionalPrice =
    showPromotional && products.some(product => !!product?.promotionalPrice);

  const [showConfirmPostModal, setConfirmPostModal] = useState(false);
  const [showConfirmPostModalCupons, setConfirmPostModalCupons] =
    useState(false);
  const [showProductCategoryModal, setShowProductCategoryModal] =
    useState(false);

  const navigateToProducts = (coupon?: CouponDTO) => {
    if (!tipo) {
      return;
    }
    navigation.navigate('Products', {
      localidade: data.state,
      tipo,
      categoria: data.categoria,
      cidade: data.cidade,
      estado: data.localidade,
      posto: data,
      coupon,
      products: [],
    });
  };

  async function handleStation(coupon?: CouponDTO) {
    if (actionBeforeNavigate) {
      actionBeforeNavigate();
    }

    await analytics().logEvent('select_content', {
      content_type: 'informacao_posto - ' + data.state,
      item_id: data.state,
    });

    if (tipo) {
      if (tipo === 'C' && products) {
        const sortedProducts = products
          .sort(function (a: any, b: any) {
            function value(el: number) {
              const x = el;
              return x === 0 || x === null ? Infinity : x;
            }

            return value(a.ordem) - value(b.ordem);
          })
          .filter((item: any) => item.region === data.state);



        return navigation.navigate('Fuel', {
          localidade: {
            cidade: data.cidade,
            estado: data.localidade,
            rank: data.categoria,
            region: data.state,
            tipo,
            isUserLocation,
          },
          posto: data,
          fuels: sortedProducts,
          coupon,
        });
      }

      navigateToProducts(coupon);
    } else {
      navigation.navigate('Station', {item: data});
    }
  }

  const fetchPromotions = useCallback(async () => {
    try {
      const response = await apiv2.get('/descontosPostoNovo', {
        params: {
          posto: data.id,
          clientId,
          isWebview,
        },
      });

      if (response.data.success) {
        setDiscounts(response.data.descontos);
      } else {
        return response.data.message;
      }
    } catch ({response}: any) {
      if (response.data.error) {
        return response.data.error;
      } else {
        return 'Não foi possível listar os descontos.';
      }
    }
  }, []);

  async function fetchProductsWithDiscount() {
    try {
      const response = await apiv2.get('/postos_banner', {
        params: {
          posto: data.id,
        },
      });

      if (response.data) {
        setAvailableProductsTypes(response.data.produtos);
        setAvailableProductBanner(response.data.texto_banner);
      }
    } catch ({response}: any) {
      if (response.data.error) {
        return response.data.error;
      } else {
        return 'Não foi possível listar os descontos.';
      }
    }
  }

  useEffect(() => {
    if (data.desconto && isLogged) {
      fetchPromotions();
    } else {
      setDiscounts([]);
    }
  }, [data.desconto, isLogged]);

  useEffect(() => {
    if (data?.loja_visivel && isLogged) {
      fetchProductsWithDiscount();
    }
  }, [data?.loja_visivel, isLogged]);

  const prosseguirParaPosto = () => {
    !showStationDetails ? handleStation() : setConfirmPostModal(true);
  };

  const handleStationPress = () => {

    // posto com preço promocional pendente de SMS: qualquer toque no card leva ao OTP
    if (hasPromotionalPrice) {
      otpAbertoAqui.current = true;
      setShouldShowOTPModal(true);
      return;
    }
    prosseguirParaPosto();
  };

  // "Agora não" (ou X/backdrop) no OTP: segue para o posto com o preço normal.
  // O modal é global, então o ref garante que só o card que o abriu reage.
  useEffect(() => {
    if (otpAbertoAqui.current && !shouldShowOTPModal) {
      otpAbertoAqui.current = false;
      if (!user.phone_verified) {
        prosseguirParaPosto();
      }
    }
  }, [shouldShowOTPModal]);

  const handleCuponsPress = () =>
    !isLogged ? setShowSign(true) : setConfirmPostModalCupons(true);

  const handleProductsPress = () =>
    !isLogged ? setShowSign(true) : setShowProductCategoryModal(true);

  const [isPressed, setIsPressed] = useState(false);
  // Conteúdo do card do posto (usado em ambos os casos: com e sem Step)
  const stationCardContent = (
    <>
      <Container
        onPress={handleStationPress}
        onPressIn={() => setIsPressed(true)}
        onPressOut={() => setIsPressed(false)}
        disabled={data.indisponivel}
        activeOpacity={1}>
        {discounts.length > 0 && !data.indisponivel && (
          <PromotionWrapper
          activeOpacity={1}
          onPress={handleCuponsPress}
            style={{
              opacity: data.indisponivel ? 0.4 : 1,
            }}>
            <PromotionContainer  >
              <PromotionBanner>
                <PromotionIconContainer>
                  <PromotionEmoji name="local-fire-department" />
                </PromotionIconContainer>
                <PromotionContent>
                  <PromotionBannerColumn>
                    <PromotionText>
                      Posto com +
                      <PromotionTextBold> descontos!</PromotionTextBold>
                    </PromotionText>
                  </PromotionBannerColumn>
                  <WhiteLine />
                  <PromotionBannerColumn
                    style={{justifyContent: 'space-between'}}>
                    <PromotionText>Pegar cupom</PromotionText>
                    <PromotionIconRight name="chevron-right" />
                  </PromotionBannerColumn>
                </PromotionContent>
              </PromotionBanner>
            </PromotionContainer>
            <PromotionArrow />
          </PromotionWrapper>
        )}

        <StationContainer>
          {data.indisponivel && (
            <StationNaoDisponivel
              style={{
                borderTopLeftRadius:
                  discounts.length > 0 && !data.indisponivel
                    ? RFValue(40)
                    : RFValue(20),
              }}>
              <StationIcon name="lock" />
              <StationTextNaoDisponivel>
                Indisponível temporariamente
              </StationTextNaoDisponivel>
              <StationSubtitleNaoDisponivel>
                Voltará em breve
              </StationSubtitleNaoDisponivel>
            </StationNaoDisponivel>
          )}

          <StationNaoDisponivel
            pointerEvents="none"
            style={{
              opacity: isPressed ? 0.3 : 0,
              borderTopLeftRadius:
                discounts.length > 0 && !data.indisponivel
                  ? RFValue(40)
                  : RFValue(20),
            }}
          />

          <Station
            style={{
              opacity: data.indisponivel ? 0.4 : 1,
              borderTopLeftRadius:
                discounts.length > 0 && !data.indisponivel
                  ? RFValue(40)
                  : RFValue(20),
            }}>
            <StationContent>
              <StationColumn>
                <StationImage source={{uri: data.flag_image}} />

                <StationInfos>
                  <StationDetails>
                    <StationAddress numberOfLines={1} ellipsizeMode="tail">
                      {data.neighbourhood}
                    </StationAddress>
                  </StationDetails>
                  <StationNameMedal>
                    <StationName numberOfLines={1} ellipsizeMode="tail">
                      {data.name}
                    </StationName>
                  </StationNameMedal>
                </StationInfos>
              </StationColumn>
              <StationColumnRight showRank={showRank}>
                {data.distance ? (
                  <DistanceContainer>
                    <DistanceIcon name="map-pin" />
                    <Distance>{data.distance} km</Distance>
                  </DistanceContainer>
                ) : (
                  !disableAction && <Arrow name="chevron-right" />
                )}
              </StationColumnRight>
            </StationContent>

            {showFuelPrices && hasPromotionalPrice && (
              <OTPWarning onPress={() => setShouldShowOTPModal(true)}>
                Valide seu telefone por SMS e aproveite a oferta!{' '}
                <OTPWarningLight>*Para novos clientes.</OTPWarningLight>
              </OTPWarning>
            )}

            {showRank && (
              <Badge>
                <BadgeTriangle rank={rank} />

                {rank === 'gold' ? (
                  <BadgeText rank={rank}>
                    Super <BadgeTextBig>Barato</BadgeTextBig>{' '}
                  </BadgeText>
                ) : (
                  <BadgeText rank={rank}>
                    <BadgeTextBig>Barato</BadgeTextBig>
                  </BadgeText>
                )}
              </Badge>
            )}
          </Station>

          {showFuelPrices && tipo === 'C' && (
            <PricesContainer
              style={{
                opacity: data.indisponivel ? 0.4 : 1,
              }}>
              <AutoScrollPrices
                products={products}
                onPress={handleStationPress}
                showPromotional={showPromotional}
              />
            </PricesContainer>
          )}
        </StationContainer>

        {Platform.OS !== 'web' && availableProductTypes.length > 0 && (
          <DiscountContainer activeOpacity={0.7} onPress={handleProductsPress}>
            <DiscountBanner>
              <DiscountIconContainer>
                <DiscountEmoji name="percent" />
              </DiscountIconContainer>
              <DiscountContent>
                <DiscountBannerColumn>
                  <DiscountText numberOfLines={1} ellipsizeMode="tail">{availableProductBanner}</DiscountText>
                </DiscountBannerColumn>
                <DiscountBannerColumn style={{justifyContent: 'space-between'}}>
                  <DiscountIconRight name="chevron-right" />
                </DiscountBannerColumn>
              </DiscountContent>
            </DiscountBanner>
          </DiscountContainer>
        )}

        <ConfirmPostModal
          onDismiss={() => setConfirmPostModal(false)}
          data={data}
          showModal={showConfirmPostModal}
          onConfirm={handleStation}
        />
        <CuponsModal
          onDismiss={() => setConfirmPostModalCupons(false)}
          onSelectCoupon={coupon => {
            handleStation(coupon);
            setConfirmPostModalCupons(false);
          }}
          discounts={discounts}
          showModal={showConfirmPostModalCupons}
        />
        <ProductCategoryModal
          onConfirm={(pProducts, pLoja, pTipo) => {
            setShowProductCategoryModal(false);
            navigation.navigate('Products', {
              localidade: pLoja.state,
              tipo: pTipo,
              categoria: pLoja.categoria,
              cidade: pLoja.city,
              estado: pLoja.localidade,
              posto: pLoja,
              products: pProducts,
            });
          }}
          onDismiss={() => setShowProductCategoryModal(false)}
          showModal={showProductCategoryModal}
          availableTypes={availableProductTypes}
        />
      </Container>
    </>
  );

  if (stepOrder && products) {
    return (
      <Step
        contextName="welcome"
        order={stepOrder}
        text={stepText ?? ''}
        onPress={stepOnPress}>
        <StationContext>{stationCardContent}</StationContext>
      </Step>
    );
  }

  return <StationContext>{stationCardContent}</StationContext>;
}
